<template>
  <div class="auditoria-page">
    <DataTable
      title="Publicações"
      subtitle="Listagem e exportação (inclui registros excluídos)"
      title-icon="fas fa-file-pdf"
      :data="items"
      :columns="columns"
      :loading="loading"
      :custom-filters="filters"
      search-placeholder="Buscar por título ou descrição..."
      empty-title="Nenhuma publicação encontrada"
      empty-message="Não há publicações para os concursos permitidos."
      empty-icon="fas fa-file-pdf"
      :show-view="false"
      :show-edit="false"
      :show-delete="false"
      @filter="onFilter"
    >
      <template #header-actions>
        <button class="btn btn-success" @click="exportar" :disabled="exporting">
          <i :class="exporting ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i>
          {{ exporting ? 'Exportando...' : 'Exportar' }}
        </button>
      </template>

      <template #cell-deleted_at="{ value }">
        <span v-if="value" class="badge badge-danger">Excluído</span>
        <span v-else class="badge badge-success">Ativo</span>
      </template>

      <template #cell-caminho_arquivo="{ value }">
        <a
          v-if="value"
          :href="value"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-sm btn-outline-primary"
        >
          <i class="fas fa-external-link-alt"></i>
          Visualizar
        </a>
        <span v-else>-</span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import axios from 'axios'
import DataTable from '@/components/admin/DataTable.vue'

export default {
  name: 'AuditoriaPublicacoes',
  components: { DataTable },
  data() {
    return {
      loading: false,
      exporting: false,
      items: [],
      concursos: [],
      tableFilters: { search: '', concurso_id: '' },
      columns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'concurso.titulo', label: 'Concurso', sortable: true },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'data_publicacao', label: 'Data', sortable: true, type: 'date' },
        { key: 'created_at', label: 'Criado em', sortable: true, type: 'date' },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'caminho_arquivo', label: 'Anexo', sortable: false },
        { key: 'deleted_at', label: 'Registro', sortable: true }
      ],
      filters: [{ key: 'concurso_id', label: 'Concurso', placeholder: 'Todos os concursos', options: [] }]
    }
  },
  async mounted() {
    await Promise.all([this.carregarConcursos(), this.carregar()])
  },
  methods: {
    async carregarConcursos() {
      try {
        const { data } = await axios.get('/ps/auditoria/concursos')
        this.concursos = Array.isArray(data) ? data : []
        this.filters[0].options = this.concursos.map(c => ({
          value: c.id,
          label: `${c.prefeitura} - ${c.titulo}`
        }))
      } catch (e) {
        console.error('Erro ao carregar concursos auditoria (filtros):', e)
      }
    },
    async carregar(params = {}) {
      this.loading = true
      try {
        const { data } = await axios.get('/ps/auditoria/publicacoes', { params })
        this.items = Array.isArray(data) ? data : []
      } catch (e) {
        console.error('Erro ao carregar publicações auditoria:', e)
        this.$sweet.showError('Erro ao carregar publicações')
      } finally {
        this.loading = false
      }
    },
    onFilter(filters) {
      this.tableFilters = filters || { search: '', concurso_id: '' }
    },
    async exportar() {
      this.exporting = true
      try {
        this.$sweet.showInfo('Gerando arquivo Excel...')
        const response = await axios.get('/ps/auditoria/publicacoes/exportar-excel', {
          params: this.tableFilters,
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `auditoria_publicacoes_${new Date().getTime()}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$sweet.showSuccess('Arquivo exportado com sucesso!')
      } catch (e) {
        console.error('Erro ao exportar publicações auditoria:', e)
        this.$sweet.showError('Erro ao exportar dados')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auditoria-page {
  .badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }
  .badge-success {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
  }
  .badge-danger {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
  }
}
</style>

